import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminJotcoachSessions: build.query<
      GetV2AdminJotcoachSessionsApiResponse,
      GetV2AdminJotcoachSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotcoach/sessions`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          organization_id: queryArg.organizationId,
          user_id: queryArg.userId,
          note_id: queryArg.noteId,
          search: queryArg.search,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          date_field: queryArg.dateField,
          sms_status: queryArg.smsStatus,
          feedback_status: queryArg.feedbackStatus,
        },
      }),
    }),
    getV2AdminJotcoachSessionsAnalyticsDashboard: build.query<
      GetV2AdminJotcoachSessionsAnalyticsDashboardApiResponse,
      GetV2AdminJotcoachSessionsAnalyticsDashboardApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotcoach/sessions/analytics/dashboard`,
        params: {
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
        },
      }),
    }),
    getV2AdminJotcoachSessionsAnalyticsOrganizations: build.query<
      GetV2AdminJotcoachSessionsAnalyticsOrganizationsApiResponse,
      GetV2AdminJotcoachSessionsAnalyticsOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotcoach/sessions/analytics/organizations`,
        params: {
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
        },
      }),
    }),
    getV2AdminJotcoachSessionsAnalyticsUsers: build.query<
      GetV2AdminJotcoachSessionsAnalyticsUsersApiResponse,
      GetV2AdminJotcoachSessionsAnalyticsUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotcoach/sessions/analytics/users`,
        params: {
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
        },
      }),
    }),
    deleteV2AdminJotcoachSessionsBySessionId: build.mutation<
      DeleteV2AdminJotcoachSessionsBySessionIdApiResponse,
      DeleteV2AdminJotcoachSessionsBySessionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotcoach/sessions/${queryArg.sessionId}`,
        method: "DELETE",
      }),
    }),
    getV2AdminJotcoachSessionsBySessionId: build.query<
      GetV2AdminJotcoachSessionsBySessionIdApiResponse,
      GetV2AdminJotcoachSessionsBySessionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotcoach/sessions/${queryArg.sessionId}`,
      }),
    }),
    getV2ProviderJotcoachEncounterSessions: build.query<
      GetV2ProviderJotcoachEncounterSessionsApiResponse,
      GetV2ProviderJotcoachEncounterSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotcoach/encounter-sessions`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderJotcoachEncounterSessionsByEncounterId: build.query<
      GetV2ProviderJotcoachEncounterSessionsByEncounterIdApiResponse,
      GetV2ProviderJotcoachEncounterSessionsByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotcoach/encounter-sessions/${queryArg.encounterId}`,
      }),
    }),
    getV2ProviderJotcoachRules: build.query<
      GetV2ProviderJotcoachRulesApiResponse,
      GetV2ProviderJotcoachRulesApiArg
    >({
      query: () => ({ url: `/v2/provider/jotcoach/rules` }),
    }),
    getV2ProviderJotcoachSessions: build.query<
      GetV2ProviderJotcoachSessionsApiResponse,
      GetV2ProviderJotcoachSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotcoach/sessions`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          user_id: queryArg.userId,
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    getV2ProviderJotcoachSessionsByNoteByNoteId: build.query<
      GetV2ProviderJotcoachSessionsByNoteByNoteIdApiResponse,
      GetV2ProviderJotcoachSessionsByNoteByNoteIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotcoach/sessions/by-note/${queryArg.noteId}`,
      }),
    }),
    getV2ProviderJotcoachSessionsBySessionId: build.query<
      GetV2ProviderJotcoachSessionsBySessionIdApiResponse,
      GetV2ProviderJotcoachSessionsBySessionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotcoach/sessions/${queryArg.sessionId}`,
      }),
    }),
    postV2ProviderJotcoachSessionsBySessionIdFeedback: build.mutation<
      PostV2ProviderJotcoachSessionsBySessionIdFeedbackApiResponse,
      PostV2ProviderJotcoachSessionsBySessionIdFeedbackApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotcoach/sessions/${queryArg.sessionId}/feedback`,
        method: "POST",
        body: queryArg.submitFeedbackRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminJotcoachSessionsApiResponse =
  /** status 200 OK */ ListResponseSessionListItemResponse;
export type GetV2AdminJotcoachSessionsApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
  /** Filter by organization ID */
  organizationId?: string | null;
  /** Filter by provider/user ID */
  userId?: string | null;
  /** Filter by note ID */
  noteId?: string | null;
  /** Search by session ID, user ID, or organization ID */
  search?: string | null;
  /** Filter by start date (inclusive) */
  startDate?: string | null;
  /** Filter by end date (inclusive) */
  endDate?: string | null;
  /** Date field to filter on: created_at, updated_at, or sent_at */
  dateField?: string | null;
  /** Filter by SMS status: 'sent' (has sent_at), 'not_sent' (no sent_at), or omit for all */
  smsStatus?: string | null;
  /** Filter by feedback status: 'has_feedback' (has user_feedback), 'no_feedback' (no user_feedback), or omit for all */
  feedbackStatus?: string | null;
};
export type GetV2AdminJotcoachSessionsAnalyticsDashboardApiResponse =
  /** status 200 OK */ DashboardAnalyticsResponse;
export type GetV2AdminJotcoachSessionsAnalyticsDashboardApiArg = {
  /** Filter by start date (inclusive) */
  startDate?: string | null;
  /** Filter by end date (inclusive) */
  endDate?: string | null;
};
export type GetV2AdminJotcoachSessionsAnalyticsOrganizationsApiResponse =
  /** status 200 OK */ OrganizationLeaderboardResponse;
export type GetV2AdminJotcoachSessionsAnalyticsOrganizationsApiArg = {
  /** Filter by start date (inclusive) */
  startDate?: string | null;
  /** Filter by end date (inclusive) */
  endDate?: string | null;
};
export type GetV2AdminJotcoachSessionsAnalyticsUsersApiResponse =
  /** status 200 OK */ UserActivityReportResponse;
export type GetV2AdminJotcoachSessionsAnalyticsUsersApiArg = {
  /** Filter by start date (inclusive) */
  startDate?: string | null;
  /** Filter by end date (inclusive) */
  endDate?: string | null;
};
export type DeleteV2AdminJotcoachSessionsBySessionIdApiResponse =
  /** status 200 OK */ SessionDeleteResponse;
export type DeleteV2AdminJotcoachSessionsBySessionIdApiArg = {
  sessionId: string;
};
export type GetV2AdminJotcoachSessionsBySessionIdApiResponse =
  /** status 200 OK */ AdminSessionDetailResponse;
export type GetV2AdminJotcoachSessionsBySessionIdApiArg = {
  sessionId: string;
};
export type GetV2ProviderJotcoachEncounterSessionsApiResponse =
  /** status 200 OK */ ListResponseEncounterSessionListItemResponse;
export type GetV2ProviderJotcoachEncounterSessionsApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2ProviderJotcoachEncounterSessionsByEncounterIdApiResponse =
  /** status 200 OK */ EncounterSessionResponse;
export type GetV2ProviderJotcoachEncounterSessionsByEncounterIdApiArg = {
  encounterId: string;
};
export type GetV2ProviderJotcoachRulesApiResponse =
  /** status 200 OK */ JotCoachRulesResponse;
export type GetV2ProviderJotcoachRulesApiArg = void;
export type GetV2ProviderJotcoachSessionsApiResponse =
  /** status 200 OK */ ListResponseSessionResponse;
export type GetV2ProviderJotcoachSessionsApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
  /** Filter by specific provider/user ID */
  userId?: string | null;
  /** Filter by organization ID */
  organizationId?: string | null;
};
export type GetV2ProviderJotcoachSessionsByNoteByNoteIdApiResponse =
  /** status 200 OK */ SessionResponse2;
export type GetV2ProviderJotcoachSessionsByNoteByNoteIdApiArg = {
  noteId: string;
};
export type GetV2ProviderJotcoachSessionsBySessionIdApiResponse =
  /** status 200 OK */ SessionResponse2;
export type GetV2ProviderJotcoachSessionsBySessionIdApiArg = {
  sessionId: string;
};
export type PostV2ProviderJotcoachSessionsBySessionIdFeedbackApiResponse =
  /** status 200 OK */ SubmitFeedbackResponse;
export type PostV2ProviderJotcoachSessionsBySessionIdFeedbackApiArg = {
  sessionId: string;
  submitFeedbackRequest: SubmitFeedbackRequest;
};
export type SessionListItemResponse = {
  /** Session creation timestamp */
  created_at: string;
  /** Number of provider feedback items submitted */
  feedback_count?: number;
  /** Whether session has any provider feedback */
  has_feedback?: boolean;
  /** Whether SMS was sent */
  has_sms?: boolean;
  /** Session identifier */
  jotcoach_session_id: string;
  /** Associated note ID */
  note_id?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Organization name (enriched) */
  organization_name?: string | null;
  /** Timestamp when SMS nudge was sent */
  sent_at?: string | null;
  /** Last update timestamp */
  updated_at: string;
  /** User email (enriched) */
  user_email?: string | null;
  /** Provider/user ID */
  user_id: string;
  /** User name (enriched) */
  user_name?: string | null;
};
export type ListResponseSessionListItemResponse = {
  items: SessionListItemResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type DashboardAnalyticsResponse = {
  /** Percentage of SMS-sent sessions that received feedback (0-100) */
  feedback_response_rate: number;
  /** Number of sessions that have at least one feedback item */
  sessions_with_feedback: number;
  /** Number of sessions where SMS was sent */
  sessions_with_sms: number;
  /** Percentage of sessions where SMS was sent (0-100) */
  sms_rate: number;
  /** Total feedback items across all sessions */
  total_feedback_count: number;
  /** Total number of sessions */
  total_sessions: number;
  /** Number of unique organizations using JotCoach */
  unique_organizations: number;
  /** Number of unique providers using JotCoach */
  unique_users: number;
};
export type OrganizationStatsResponse = {
  /** Total feedback items for this organization */
  feedback_count: number;
  /** Average feedback items per session */
  feedback_rate: number;
  /** Organization ID */
  organization_id: string;
  /** Organization name (enriched from org service) */
  organization_name?: string | null;
  /** Total sessions for this organization */
  session_count: number;
  /** Number of unique providers in this organization */
  unique_users: number;
};
export type OrganizationLeaderboardResponse = {
  /** List of top organizations by session count */
  organizations: OrganizationStatsResponse[];
  /** Total number of organizations in leaderboard */
  total_organizations: number;
};
export type UserStatsResponse = {
  /** Total feedback items from this user */
  feedback_count: number;
  /** Average feedback items per session */
  feedback_rate: number;
  /** Organization ID */
  organization_id: string;
  /** Organization name (enriched from org service) */
  organization_name?: string | null;
  /** Total sessions for this user */
  session_count: number;
  /** User email (enriched from user service) */
  user_email?: string | null;
  /** Provider/user ID */
  user_id: string;
  /** User name (enriched from user service) */
  user_name?: string | null;
};
export type UserActivityReportResponse = {
  /** Total number of users in report */
  total_users: number;
  /** List of top users by session count */
  users: UserStatsResponse[];
};
export type SessionDeleteResponse = {
  /** Human-readable message */
  message: string;
  /** Session ID that was deleted */
  session_id: string;
  /** Whether deletion was successful */
  success: boolean;
};
export type SessionDataResponse = {
  /** Documentation analysis: quality scores, gaps (with id, description 10-16 words), provider_questions (with id, must end with ?), billing support */
  documentation_analysis?: {
    [key: string]: any;
  } | null;
  /** Full billing gap analysis report (v1 legacy) */
  gap_analysis?: string | null;
  /** Chat message history (list of message objects) */
  message_history?: {
    [key: string]: any;
  }[];
  /** Session analysis: session type, complexity, CPT suggestions, transcript_origin, participants, modalities */
  session_analysis?: {
    [key: string]: any;
  } | null;
  /** SMS message sent to clinician (v1 legacy) */
  sms_nudge?: string | null;
  /** Synthesized feedback: detailed_feedback (≤800 chars), sms_friendly_feedback (≤480 chars) */
  synthesized_feedback?: {
    [key: string]: any;
  } | null;
  /** Provider feedback events on gaps, questions, and session quality */
  user_feedback?: {
    [key: string]: any;
  }[];
};
export type AdminSessionDetailResponse = {
  /** Session creation timestamp */
  created_at: string;
  /** Number of provider feedback items submitted for this session */
  feedback_count?: number;
  /** Session identifier */
  jotcoach_session_id: string;
  /** Associated note ID */
  note_id?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Organization name (enriched) */
  organization_name?: string | null;
  /** Timestamp when SMS nudge was successfully sent via Twilio */
  sent_at?: string | null;
  /** Session content */
  session_data: SessionDataResponse;
  /** Last update timestamp */
  updated_at: string;
  /** User email (enriched) */
  user_email?: string | null;
  /** Provider/user ID */
  user_id: string;
  /** User name (enriched) */
  user_name?: string | null;
};
export type EncounterSessionListItemResponse = {
  /** Session creation timestamp */
  created_at: string;
  /** Document ID (jotdoc or note UUID) */
  document_id: string;
  /** Document type: 'jotdoc' or 'note' */
  document_type: string;
  /** Encounter ID */
  encounter_id: string;
  /** Brief summary of key flags and critical risks from rules analysis */
  flags_summary?: string | null;
  /** Parent encounter session identifier (UUID) */
  jotcoach_encounter_session_id: string;
  /** Note ID associated with the encounter */
  note_id?: string | null;
  /** Organization ID for the session */
  organization_id: string;
  /** Overall quality score (1-5) from rules analysis */
  overall_quality_score?: number | null;
  /** Patient ID associated with the encounter */
  patient_id?: string | null;
  /** Patient display name (preferred_name or first_name with last_name) */
  patient_name?: string | null;
  /** Provider name (signing_name or name) */
  provider_name?: string | null;
  /** Selected CPT code from session analysis (primary code) */
  selected_cpt_code?: string | null;
  /** Last update timestamp */
  updated_at: string;
  /** User ID (provider) */
  user_id: string;
};
export type ListResponseEncounterSessionListItemResponse = {
  items: EncounterSessionListItemResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type EncounterSessionResponse = {
  /** Session creation timestamp */
  created_at: string;
  /** Encounter ID */
  encounter_id: string;
  /** Session identifier (UUID) */
  jotcoach_encounter_session_id: string;
  /** Organization ID for the session */
  organization_id: string;
  /** Dictionary of workflow details keyed by prefixed document IDs (e.g., 'jotdoc:uuid' or 'note:uuid') */
  sessions?: {
    [key: string]: {
      [key: string]: any;
    };
  };
  /** Last update timestamp */
  updated_at: string;
  /** User ID (provider) */
  user_id: string;
};
export type RuleFacets = {
  /** Applicable CPT codes */
  cpt?: string[];
  /** Applicable payers (e.g., Optum, Medicare) */
  payer?: string[];
  /** Applicable provider types (e.g., PMHNP) */
  provider_type?: string[];
};
export type RuleOwnerScope = "public" | "org" | "user";
export type RuleSource = {
  /** Date of source document (YYYY-MM-DD or string) */
  document_date?: string | null;
  /** Title of source document */
  document_title?: string | null;
  /** URI/URL to source document */
  source_uri?: string | null;
};
export type RuleState = "active" | "deprecated";
export type ComplianceRule = {
  /** When true, rule bypasses LLM selection and is always included */
  always_select?: boolean;
  /** Canonical Markdown content: Rule, Applies when, What good looks like, Why it matters */
  body_md: string;
  /** Sparse applicability filters: cpt, provider_type, payer */
  facets?: RuleFacets;
  /** Owning organization UUID when not public */
  organization_id?: string | null;
  /** Scope of the rule: public, org, or user */
  owner_scope?: RuleOwnerScope;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Compact one-liner for LLM rule selection (~100-150 chars) */
  selector_text: string;
  /** Source documentation: document_title, document_date, source_uri */
  source?: RuleSource;
  /** Rule lifecycle state: active or deprecated */
  state?: RuleState;
  /** Short human-readable label */
  title?: string | null;
};
export type JotCoachRulesResponse = {
  /** List of compliance rules for JotCoach */
  rules: ComplianceRule[];
  /** Total number of rules */
  total: number;
};
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type SessionDataResponse2 = {
  /** Documentation analysis: quality scores, gaps (with id, description 10-16 words), provider_questions (with id, must end with ?), billing support */
  documentation_analysis?: {
    [key: string]: any;
  } | null;
  /** Full billing gap analysis report (v1 legacy) */
  gap_analysis?: string | null;
  /** Chat message history (list of message objects) */
  message_history?: {
    [key: string]: any;
  }[];
  /** Session analysis: session type, complexity, CPT suggestions, transcript_origin, participants, modalities */
  session_analysis?: {
    [key: string]: any;
  } | null;
  /** SMS message sent to clinician (v1 legacy) */
  sms_nudge?: string | null;
  /** Synthesized feedback: detailed_feedback (≤800 chars), sms_friendly_feedback (≤480 chars) */
  synthesized_feedback?: {
    [key: string]: any;
  } | null;
  /** Provider feedback events on gaps, questions, and session quality */
  user_feedback?: {
    [key: string]: any;
  }[];
};
export type SessionResponse = {
  /** Session creation timestamp */
  created_at: string;
  /** Session identifier */
  jotcoach_session_id: string;
  /** Associated note ID */
  note_id?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Timestamp when SMS nudge was successfully sent via Twilio */
  sent_at?: string | null;
  /** Session content */
  session_data: SessionDataResponse2;
  /** Last update timestamp */
  updated_at: string;
  /** Provider/user ID */
  user_id: string;
};
export type ListResponseSessionResponse = {
  items: SessionResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type SessionDataResponse3 = {
  /** Documentation analysis: quality scores, gaps (with id, description 10-16 words), provider_questions (with id, must end with ?), billing support */
  documentation_analysis?: {
    [key: string]: any;
  } | null;
  /** Full billing gap analysis report (v1 legacy) */
  gap_analysis?: string | null;
  /** Chat message history (list of message objects) */
  message_history?: {
    [key: string]: any;
  }[];
  /** Session analysis: session type, complexity, CPT suggestions, transcript_origin, participants, modalities */
  session_analysis?: {
    [key: string]: any;
  } | null;
  /** SMS message sent to clinician (v1 legacy) */
  sms_nudge?: string | null;
  /** Synthesized feedback: detailed_feedback (≤800 chars), sms_friendly_feedback (≤480 chars) */
  synthesized_feedback?: {
    [key: string]: any;
  } | null;
  /** Provider feedback events on gaps, questions, and session quality */
  user_feedback?: {
    [key: string]: any;
  }[];
};
export type SessionResponse2 = {
  /** Session creation timestamp */
  created_at: string;
  /** Session identifier */
  jotcoach_session_id: string;
  /** Associated note ID */
  note_id?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Timestamp when SMS nudge was successfully sent via Twilio */
  sent_at?: string | null;
  /** Session content */
  session_data: SessionDataResponse3;
  /** Last update timestamp */
  updated_at: string;
  /** Provider/user ID */
  user_id: string;
};
export type SubmitFeedbackResponse = {
  /** Number of feedback items added */
  feedback_count: number;
  message?: string;
  /** Session ID that was updated */
  session_id: string;
};
export type FeedbackItemRequest = {
  /** Optional comment from provider */
  comment?: string;
  /** Whether the item was useful */
  is_useful: boolean;
  /** Optional note ID that this feedback relates to */
  note_id?: string | null;
  /** Optional section ID within the note that this feedback relates to */
  section_id?: string | null;
  /** ID of the item (gap.id, question.id, or 'session_overall') */
  target_id: string;
  /** Type of item being rated */
  target_type: "gap" | "question" | "session_overall";
};
export type SubmitFeedbackRequest = {
  /** List of feedback items (supports batch submission) */
  feedback_items: FeedbackItemRequest[];
};
